import { toast } from 'react-toastify';
import './NotificationDisplayStyles.css';
import { Logger } from 'UI-Dash-Commons-UI';

export const MESSAGE_TYPES = {
    SUCCESS: 'SUCCESS',
    INFO: 'INFO',
    ERROR: 'ERROR',
    PERSISTENT_ERROR: 'PERSISTENT_ERROR',
    ADBLOCKER_ERROR: 'ADBLOCKER_ERROR'
};


/**
 * This class is used to show various notification messages to the user
 */
const TAG = 'NotificationDisplayUtils';
export default class NotificationDisplayUtils
{
    static get TYPE_SUCCESS()
    {

        return MESSAGE_TYPES.SUCCESS;
    }

    static get TYPE_ERROR()
    {

        return MESSAGE_TYPES.ERROR;
    }

    static get TYPE_INFO()
    {

        return MESSAGE_TYPES.INFO;
    }

    static get TYPE_PERSISTENT_ERROR()
    {
        return MESSAGE_TYPES.PERSISTENT_ERROR;
    }

    static get TYPE_ADBLOCKER_ERROR()
    {
        return MESSAGE_TYPES.ADBLOCKER_ERROR;
    }

    /**
     * Show success error message
     * @param message Localized success text to show
     * @param type Type of the message
     */
    static showMessage( message: string, type: NotificationDisplayUtils )
    {
        if ( type === NotificationDisplayUtils.TYPE_SUCCESS )
        {
            toast.success( message );
        }
        else if ( type === NotificationDisplayUtils.TYPE_INFO )
        {
            toast.info( message );
        }
        else if ( type === NotificationDisplayUtils.TYPE_ERROR )
        {
            toast.error( message );
        }
        else if ( type === NotificationDisplayUtils.TYPE_PERSISTENT_ERROR )
        {
            toast.error( message, {
                autoClose: false,
                closeButton: true,
                closeOnClick: true,
                draggable: false,
            } );
        }
        else if ( type === NotificationDisplayUtils.TYPE_ADBLOCKER_ERROR )
        {
            toast.error( message,
                {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: false,
                    closeButton: false,
                    closeOnClick: false,
                    draggable: false,
                    className: 'adBlockerNotification'
                } );
        }
        else
        {
            Logger.error( TAG, `Unknown message type: ${type}` );
        }
    }

}
